import type { FirmaExportPortal } from '@ahd/shared/types/ahd-cars/firma/export-portale';
import type { MobileDealerSettings } from '@ahd/shared/types/ahd-cars/firma/mobile-dealer-settings';
import axios from './Axios';
import { getAxiosHeader, urlExportRelease } from './AxiosVars';

/*
 * Portal Valid/Invalid setzen
 */
export function swapPortal(idFirma, idPortal) {
    const url = urlExportRelease + '/s/v1/status/swapPortal/' + idFirma + '/' + idPortal;
    return axios({
        title: 'Umschalten des Portals',
        method: 'post',
        url: url,
        headers: getAxiosHeader(),
    });
}

export function addTask(idCar) {
    const url = urlExportRelease + '/eMymo/v1/task';
    return axios({
        title: 'Eintragen des EVA-Import',
        method: 'post',
        url: url,
        headers: getAxiosHeader(),
        data: idCar,
    });
}

export type Export = {
    bestand: number;
    carsUpload: number;
    datum: number;
    del: number;
    fNeu: number;
    finished: number;
    ftpdone: number;
    id: number;
    id_firma: number;
    id_user: number;
    id_subuser: number;
    id_portal: number;
    modus: number;
    neu: number;
    portalFileName: string;
    status: number;
    upl_file: string;
    upl_file_size: number;
    upl_start: number;
    upl_end: number;
};

export function getProtoExp(idFirma) {
    const url = urlExportRelease + '/s/v1/status/' + idFirma + '/current';
    return axios<Export[]>({
        title: 'Abrufen der Exportprotokolle',
        method: 'get',
        url: url,
        headers: getAxiosHeader(),
    });
}

export function startExport(idFirma, idPortal) {
    const url = urlExportRelease + '/s/v1/firma/' + idFirma + '/portal/' + idPortal;
    return axios({
        title: 'Starten des Exports',
        method: 'put',
        url: url,
        headers: getAxiosHeader(),
    });
}

export function getExportAllFirmen() {
    const url = urlExportRelease + '/s/v1/status';
    return axios<Export[]>({
        title: 'Abrufen der Exportdaten',
        method: 'get',
        url: url,
        headers: getAxiosHeader(),
    });
}

export function getPortale(idFirma) {
    const url = urlExportRelease + '/s/v1/status/' + idFirma + '/config';
    return axios<(Omit<FirmaExportPortal, 'cond'> & { cond: string })[]>({
        title: 'Abrufen der Exportdaten',
        method: 'get',
        url: url,
        headers: getAxiosHeader(),
    });
}

export function forceExport(idFirma, idPortal) {
    const url = urlExportRelease + '/s/v1/export/' + idFirma + '/99/' + idPortal + '/2';
    return axios({
        title: 'Starten des Export ohne Limit',
        method: 'get',
        url: url,
        headers: getAxiosHeader(),
    });
}

// statistik Mobile
export function getDatenMobile(idPortal) {
    const url = urlExportRelease + '/mobile/statistik/' + idPortal;
    return axios({
        title: 'Abrufen der Daten',
        method: 'get',
        url: url,
        headers: getAxiosHeader(),
    });
}

export function getMobileStat(idCar) {
    const url = urlExportRelease + '/mobile/v2/statistik/' + idCar + '/stat';
    return axios({
        title: 'Abrufen der Mobile-Statistik',
        method: 'get',
        url: url,
        headers: getAxiosHeader(),
    });
}

export function getMobileStatList(idCars, signal: AbortController['signal']) {
    const url = urlExportRelease + '/mobile/v2/statistik/stat';
    return axios({
        title: 'Laden der Trackingdaten',
        method: 'post',
        url: url,
        data: idCars.join(','),
        headers: getAxiosHeader(),
        signal: signal,
    });
}

export enum MobilePriceRange {
    VERY_GOOD_PRICE = 'VERY_GOOD_PRICE',
    GOOD_PRICE = 'GOOD_PRICE',
    REASONABLE_PRICE = 'REASONABLE_PRICE',
    INCREASED_PRICE = 'INCREASED_PRICE',
    HIGH_PRICE = 'HIGH_PRICE',
}

export type MobilePriceRangeLabel = {
    idMM: number;
    iLabel: number;
    nextLevel: number;
    label: MobilePriceRange;
    labelRanges: [
        {
            label: MobilePriceRange.VERY_GOOD_PRICE;
            from: string;
            to: string;
        },
        {
            label: MobilePriceRange.GOOD_PRICE;
            from: string;
            to: string;
        },
        {
            label: MobilePriceRange.REASONABLE_PRICE;
            from: string;
            to: string;
        },
        {
            label: MobilePriceRange.INCREASED_PRICE;
            from: string;
            to: string;
        },
        {
            label: MobilePriceRange.HIGH_PRICE;
            from: string;
            to: string;
        },
    ];
};

export function getPricerating(idCar) {
    const url = urlExportRelease + '/mobile/pricerating/' + idCar;
    return axios<MobilePriceRangeLabel>({
        title: 'Abrufen der Preisbewertung',
        method: 'get',
        url: url,
        headers: getAxiosHeader(),
    });
}

export function getMobileSellerData(idFirma: number, idPortal: number) {
    return axios<MobileDealerSettings>({
        title: 'Abrufen der Mobile Seller Data',
        method: 'get',
        url: `${urlExportRelease}/mobile/statistik/seller/${idFirma}/${idPortal}`,
        headers: getAxiosHeader(),
    });
}

export function generateMobileSettings(idFirma: number, idPortal: number, formData: FirmaExportPortal['cond'] | '') {
    return axios<FirmaExportPortal['cond']>({
        title: 'Abrufen der Mobile Settings',
        method: 'post',
        url: `${urlExportRelease}/mobile/sellersettings/${idFirma}/${idPortal}/cond`,
        data: formData,
        headers: getAxiosHeader(),
    });
}
